import gql from 'graphql-tag'

const loginQuery = gql`
  query login($login: String!, $password: String!) {
    login(input: { login: $login, password: $password })
      @rest(type: "UserToken", method: "POST", path: "login/user", endpoint: "gateway") {
      token
      refreshToken
    }
  }
`

export default loginQuery
